export default "## Geometry\n\nSome custom geometry generating components.\n\n## Nine Slice\n\n::demo{name=nine_slice}\n\n## Tilemap\n\n::demo{name=tilemap}"